<div class="flex-column w-80 h-100">
    <div
        class="p-2 text-black w-100 d-flex justify-content-between"
        data-testid="voice-payments-panel"
    >
        <span class="font-xs text-secondary ps-2 pt-2">Payments</span>
        <button
            type="button"
            class="btn-close text-reset btn-tiny"
            aria-label="Close"
            (click)="closeButtonHandler()"
        ></button>
    </div>
    <div class="w-100 d-flex h-100">
        @if (isLoading()) {
            <div class="h-100 w-100">
                <telxl-loading size="3rem" data-testid="loading-component" />
            </div>
        } @else {
            @let validUrl = sanitizedUrl();
            @if (validUrl) {
                <iframe
                    class="payments-iframe"
                    title="iFrame Payments"
                    [src]="validUrl"
                    [frameBorder]="0"
                    data-testid="payment-iframe"
                ></iframe>
            } @else {
                <div
                    class="p-2 d-flex w-100 align-items-center"
                    data-testid="unavailable-message"
                >
                    <span class="font-sm p-2">
                        Our payment service is currently unavailable. Please try
                        again later or contact our customer service team for
                        assistance. We apologise for any inconvenience.
                    </span>
                </div>
            }
        }
    </div>
</div>
